// extracted by mini-css-extract-plugin
module.exports = {"FilterByAge":"FilterByAge_FilterByAge__2I7lx","bigButton":"FilterByAge_bigButton__3UiTq","zoomHover":"FilterByAge_zoomHover__WEsLL","areaOfText":"FilterByAge_areaOfText__3P_si"};